import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { failedResponse, getBackendUrl, loaded, loading, error, LoadStateInfo, notStarted } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { RootState } from "../../app/store";

export interface ConversationUpdateReadRequest {
    conversationId: number;
    messageId: number;
}

export const performConversationUpdRead = createAsyncThunk(
    "performConversationUpdRead",
    async (param: ConversationUpdateReadRequest, thunkAPI) => {
        const response = await fetch(`${getBackendUrl()}/api/conversation/${param.conversationId}/read/${param.messageId}`, {
            method: "PATCH",
            signal: thunkAPI.signal,
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${getToken()}`,
            },
            body: JSON.stringify(param)
        });

        if (response.ok) {
            // it returns void, so 200 is more than enough
            return "OK";
        } else {
            return thunkAPI.rejectWithValue(failedResponse(response));
        }
    }
);

export interface ConversationUpdReadState {
    state: LoadStateInfo;
    request?: ConversationUpdateReadRequest;
}

const initialState: ConversationUpdReadState = {
    state: notStarted(),
};

export const conversationUpdReadSlice = createSlice({
    name: "conversationUpdReadSlice",
    initialState,
    reducers: {
        clean: (state) => {
            state.state = notStarted();
            state.request = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(performConversationUpdRead.pending, (state, action) => {
                console.info(`${action.type}`);
                state.state = loading();
                state.request = action.meta.arg;
            })
            .addCase(performConversationUpdRead.fulfilled, (state, action) => {
                console.debug(`${action.type}`);
                state.state = loaded();
            })
            .addCase(performConversationUpdRead.rejected, (state, action) => {
                console.debug(`${action.type}`);
                state.state = error(action);
            });
    },
});

export const { } = conversationUpdReadSlice.actions;

export const selectConversationUpdRead = (state: RootState) => state.conversationUpdRead;

export default conversationUpdReadSlice.reducer;
